import API from './api';
import Apollo from './apollo';
import IAM from './iam';
import Router from '../router';
import Store from '../store';

export default class Global {
  constructor(config) {
    this.iam = new IAM(config.iam);
    this.router = Router.setup(this.iam, config.router);
    this.store = Store;
    this.iam.setup(this.router, this.store);
    this.api = new API(config.api);
    this.apollo = Apollo.setup(this.iam, this.store, config.apollo);
    this.product = config.product;
    this.support = config.support;
  }
}
